var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBubbleDotsGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 21,
    height: 5,
    viewBox: "0 0 21 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    fill: "#6E6E6E"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2",
    cx: 10.5,
    cy: 2.5,
    r: 2.5,
    fill: "#6E6E6E"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3",
    cx: 18.5,
    cy: 2.5,
    r: 2.5,
    fill: "#6E6E6E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBubbleDotsGray);
export default __webpack_public_path__ + "static/media/bubble-dots-gray.169175be75bc9fa7df221c0411579eca.svg";
export { ForwardRef as ReactComponent };